export const GameConstants = {
    StartScreen: {
        focusHeightFactor: 0.45
    },
    LevelCompletedScreenShot: {
        titleFontStyle: {
            fontSize: 36,
            fill: ["#9dfd6c"],
            lineHeight: 54
        },
        subTitleFontStyle: {
            fontSize: 18,
            fill: ["#9dfd6c"],
            lineHeight: 18
        },
        scoreFontStyle: {
            fontSize: 27,
            fontWeight: "bold",
            fill: ["#4A74C6"],
            lineHeight: 20
        },
        scoreBarStyle: {
            color: 0xffffff,
            width: 120,
            height: 40,
            radius: 40 * 0.47
        },
        layoutSettings: {
            titleOffsetY: 90,
            subtitleOffsetY: -50,
            avatarOffsetY: 209,
            avatarWidth: 134,
            avatarHeight: 134,
            avatarImageYOffset: 18,
            avatarRadius: 67,
            badgeOffsetY: 137,
            winRaysOffsetY: -154,
            maxWidth: 640,
            fieldOffsetY: 241
        }
    }
};
